var map = {
	"./A.svg": 338,
	"./B.svg": 339,
	"./C.svg": 340,
	"./CH.svg": 341,
	"./D.svg": 342,
	"./E.svg": 343,
	"./F.svg": 344,
	"./G.svg": 345,
	"./H.svg": 346,
	"./I.svg": 347,
	"./J.svg": 348,
	"./K.svg": 349,
	"./L.svg": 350,
	"./LL.svg": 351,
	"./M.svg": 352,
	"./N.svg": 353,
	"./O.svg": 354,
	"./P.svg": 355,
	"./Q.svg": 356,
	"./R.svg": 357,
	"./S.svg": 358,
	"./T.svg": 359,
	"./U.svg": 360,
	"./V.svg": 361,
	"./W.svg": 362,
	"./X.svg": 363,
	"./Y.svg": 364,
	"./Z.svg": 365,
	"./Ñ.svg": 366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;